import { useTranslation } from "@luckymenu/i18n/react";
import { UiLabelsProvider } from "@luckymenu/ui-web";
import { createRootRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { SsoCallback, StaffGate } from "../features/gate";

function Root() {
	const { t } = useTranslation("common");
	const pathname = useRouterState({ select: (s) => s.location.pathname });
	return (
		// The words ui-web's dialogs draw themselves, from the shared i18n.
		<UiLabelsProvider labels={{ close: t("close") }}>
			{pathname === "/sso-callback" ? (
				<SsoCallback />
			) : (
				<StaffGate>
					<Outlet />
				</StaffGate>
			)}
		</UiLabelsProvider>
	);
}

export const Route = createRootRoute({ component: Root });
